/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import { Waveform as Wfrm } from '../Styles/index'
import { AudioContext } from '../Context'

let WaveSurfer: any = null
let WaveSurferCursorPlugin: any = null

if (typeof window !== `undefined`) {
  WaveSurfer = require('wavesurfer.js')
  WaveSurferCursorPlugin = require('wavesurfer.js/dist/plugin/wavesurfer.cursor.js')
}

const Waveform: React.FC<WaveformProps> = ({
  trackInfo,
  progressColor,
  cursorColor,
  wavesurferOptions = {},
  styles,
}) => {
  const ref = React.useRef<HTMLDivElement | null>(null)
  const { audioRef } = React.useContext(AudioContext)

  React.useEffect(() => {
    let wavesurfer: any
    if (WaveSurfer) {
      wavesurfer = WaveSurfer.create({
        barWidth: 1,
        cursorWidth: 1,
        container: ref.current,
        backend: 'MediaElement',
        height: 45,
        progressColor: progressColor,
        responsive: true,
        waveColor: '#47494c',
        cursorColor,
        removeMediaElementOnDestroy: false,
        closeAudioContext: true,
        plugins: [
          WaveSurferCursorPlugin.create({
            opacity: 0.4,
          }),
        ],
        ...wavesurferOptions,
      })

      if (audioRef) {
        wavesurfer.loadMediaElement(audioRef.current)
      }
    }
    return () => {
      if (wavesurfer) {
        wavesurfer.cancelAjax()
        wavesurfer.destroy()
      }
      return undefined
    }
  }, [trackInfo])

  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <div ref={ref} css={getStyles('waveform', {})} />
      )}
    </StyledComponent>
  )
}

export default Waveform

interface WaveformProps {
  trackInfo?: string
  progressColor?: string
  cursorColor?: string
  wavesurferOptions?: object // https://wavesurfer-js.org/docs/options.html
  styles?: Wfrm.StylesObj
}
